export enum GtmEvent {
  DirectDownload = 'directDownload',
  DirectDownloadHighres = 'directDownloadHighres',
  Search = 'search',
}
